module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 018.c343f168.jpg";